import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SubscribeButtonComponent } from './subscribe-button/subscribe-button.component';
import { SubscribeDialogComponent } from './subscribe-dialog/subscribe-dialog.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
  ],
  declarations: [SubscribeButtonComponent, SubscribeDialogComponent],
  exports: [SubscribeButtonComponent, SubscribeDialogComponent],
})
export class SubscriptionModule {}
